import { defineMessages } from 'react-intl';
// import Schema from '@plone/volto/components/manage/Blocks/Block/Schema';
import { headingSchema } from './schema';
import Edit from './Edit';
import View from './View';
import iconSVG from './icons/head-title.svg';

defineMessages({
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.heading = {
    id: 'heading',
    title: 'Heading',
    group: 'text',
    icon: iconSVG,
    view: View,
    edit: Edit,
    schema: headingSchema,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
    default_tag: 'h2',
    allowed_headings: ['h2', 'h3'],
    hide_alignment: false,
    // integration with volto-block-toc
    tocEntry: (block = {}) => {
      const { tag, heading } = block;
      return heading && tag ? [parseInt(tag.slice(1)), heading] : null;
    },

    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
